import { Modal } from "shared/ui/modal";
import { Button } from "shared/ui/button";
import { formatDateForEvent } from "shared/lib/hooks/useDateFormatting";
import styles from "./RecordDeleteConfirmModal.module.scss";

export const QrCodeModal = ({ isModalOpen, open, close, toggle, event }) => {
  const QRSrc = event?.QR || null;
  const QRUrl = QRSrc ? `data:image/png;base64,${QRSrc}` : null;
  return (
    <Modal isModalOpen={isModalOpen} open={open} close={close} toggle={toggle}>
      <div className={styles.modalContent}>
        {QRUrl ? (
          <>
            <div className={styles.modalContent__textBlock}>
              <p className={styles.modalContent__title}>{event?.header}</p>
              <p className={styles.modalContent__subTitle}>
                {formatDateForEvent(event?.plannedDate)}
              </p>
            </div>
            <img
              className={styles.modalContent__img}
              src={QRUrl}
              alt={event?.header || "Мероприятие"}
            />
          </>
        ) : (
          <div className={styles.modalContent__imgPlaceholder}>
            Билет на мероприятие появится в личном кабинете после оплаты.
          </div>
        )}
        <div className={styles.modalContent__button}>
          <Button variant="primary" size="large" onClick={close}>
            Закрыть
          </Button>
        </div>
      </div>
    </Modal>
  );
};
